import { render, staticRenderFns } from "./ColumnMetrics.vue?vue&type=template&id=efe20016&"
import script from "./ColumnMetrics.vue?vue&type=script&lang=ts&"
export * from "./ColumnMetrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports